<template>
  <el-row class="Layout">
    <el-col :span="24" class="Layout-head">
      <el-row>
        <el-col :span="7">
          <img
            :src="HomeInfo.obj.logoImg"
            alt=""
            @click="handleRoute('/')"
          >
        </el-col>
        <el-col :span="9">
          <el-menu
            :default-active="activeIndex"
            router
            menu-trigger="click"
            text-color="#555"
            active-text-color="#2f82ff"
            mode="horizontal"
            background-color="#fff"
          >
            <template v-for="(item, index) in $router.options.routes">
              <el-menu-item
                v-if="isShowMenu([item.children[0]])"
                :key="index"
                :index="item.children[0].path"
                :class="{ activeTab: activeIndex == index + 1 }"
                @click="handleActive(index)"
              >
                {{ item.children[0].name }}
              </el-menu-item>
            </template>
          </el-menu>
        </el-col>
        <el-col :span="8">
          <div class="leftBox">
            <Search />
            <div v-popover:popover>
              <el-badge :value="messageNum" :hidden="!messageNum">
                <el-avatar
                  v-if="avatarImg"
                  :size="50"
                  :src="avatarImg"
                  class="elAvatar"
                />
              </el-badge>
              <div class="logoStr">
                {{ schoolName }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="24" class="Layout-content">
      <!-- TODO:el-backtop固定了底部 应该让底部信息随页面滚动 -->
      <section>
        <el-col :span="24" class="routerBox">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </el-col>
        <el-col :span="24" class="Layout-content-btns">
          <div>{{ HomeInfo.obj.footObj.copyright }}</div>
          <div>地址：{{ HomeInfo.obj.footObj.address }}</div>
        </el-col>
      </section>
    </el-col>
    <el-popover
      ref="popover"
      width="220"
      trigger="hover"
      :append-to-body="false"
      :popper-options="{
        boundariesElement: 'leftBox',
        gpuAcceleration: true,
        positionFixed: true,
        preventOverflow: true
      }">
      <div class="Layout-head-popover">
        <div>
          <el-avatar
            v-if="avatarImg"
            :size="50"
            :src="avatarImg"
            class="elAvatar"
          />
          <span>
            <span>{{ schoolName }}</span>
            <div v-if="phone" class="phone">
              <img
                :src="require(`@/assets/icon/icon-phone.png`)"
                alt="">
              &nbsp;&nbsp;<span>{{ phone }}</span>
            </div>
            <div v-if="wx_nickname">
              <span
              ><img
                :src="require(`@/assets/icon/icon-wx.png`)"
                alt=""></span
                >&nbsp;&nbsp;<span>{{ wx_nickname }}</span>
            </div>
          </span>
        </div>
        <div>
          <div>
            <span
              class="popoverRoute" @click="handleRoute('/mine/collect')"
            >我的收藏</span
            >
          </div>
          <div>
            <span
              class="popoverRoute" @click="handleRoute('/mine/set')"
            ><span>功能设置</span></span
            >
          </div>
          <div>
            <span
              class="popoverRoute"
              @click="handleRoute('/message/details')"
            >
              <span>
                <el-badge
                  :value="messageNum" :hidden="!messageNum"
                ><span>消息通知</span></el-badge
                >
              </span>
            </span>
          </div>

          <div>
            <span
              class="popoverRoute" @click="handleRoute('/login')"
            ><span>退出登录</span></span
            >
          </div>
        </div>
      </div>
    </el-popover>
    <el-backtop target="#app" :visibility-height="100" />
  </el-row>
</template>

<script>
import Search from './search'

import { getToken, removeToken } from '@/utils/auth'
import { mapGetters, mapState } from 'vuex'
import mock from '@/utils/mock'
import api from '@/api/app'
export default {
  components: {
    Search
  },
  data() {
    return {
      HomeInfo: mock.home.Home.viewInfo,
      HomeInit: mock.home.Home.init,
      schoolName: '',
      avatarImg: require(`@/assets/dto/dto-role12.png`),
      phone: '',
      wx_nickname: ''
    }
  },
  watch: {

  },
  computed: {
    activeIndex: {
      get() {
        const arr = this.$router.options.routes
        const loginIndex = arr.findIndex((item) => {
          return item.path == '/login'
        })
        if (loginIndex != -1) {
          arr.splice(loginIndex, 1)
        }
        const arr1 = arr.filter((item) => {
          return !item.children[0].hidden
        })
        return (
          arr1.findIndex(
            (value) =>
              value.path.split('/')[1] == this.$route.path.split('/')[1]
          ) +
          1 +
          ''
        )
      },
      set(val) {}
    },
    ...mapGetters({
      user: 'user/user'
    }),
    ...mapState({
      messageNum: ({ user }) => {
        return user.message
      }
    })
  },
  mounted() {
    if (this.user && this.user.avatar) {
      this.avatarImg = this.user.avatar
    }
    if (this.user && this.user.school_name) {
      this.schoolName = this.user.school_name
    }
    if (this.user && this.user.phone) {
      this.phone = this.user.phone
    }
    if (this.user && this.user.wx_nickname) {
      this.wx_nickname = this.user.wx_nickname
    }
  },
  methods: {
    getToken() {
      return getToken()
    },
    isShowMenu(v) {
      const obj = v[0]
      if (
        obj.path == '/library' &&
        this.user &&
        ![2, 3, 4, 999].includes(this.user.school_type)
      ) {
        obj.hidden = true
      }
      if (obj.hidden) {
        return false
      } else {
        return true
      }
    },
    control(type, condition) {
      return mock.home.Home.control[type](condition)
    },
    handleActive(v) {
      this.activeIndex = Number(v) + 1 + ''
    },
    handleRoute(v) {
      if (v == '/login') {
        this.$confirm('确定退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            localStorage.removeItem('user')
            removeToken()
            window.location.reload()
          })
          .catch(() => {})
      } else {
        this.$router.push(v)
      }
    },
    handleCommand(v) {
      if (v.type == 'path') {
        this.handleRoute(v)
      }
      if (v.type == 'control') {
        if (v.path == 'logout') {
          this.HomeInit.logout()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.Layout {
  // position: absolute;
  // top: 0px;
  // bottom: 0px;
  width: 1920px;
  margin: 0 auto;
  // height: 100%;
  // overflow:hidden ;
  // overflow-x: auto;
  min-height:100%;
  padding-top:70px ;
   display: flex;
  flex-direction: column;
  align-content: center;
  &-head {
    width: 1920px;
    height: 72px;
    line-height: 72px;
    background: #fff;
    display: flex;
    min-width:$xr-min-width;
    position: fixed;
    top: 0;
    z-index: 99;
    > div {
      // min-width: 1903px;
      width: 100%;
      margin: 0 auto;
      box-shadow: 0 2px 10px 3px rgba(85, 85, 85, 0.05);
      > div {
        height: 100%;
        &:nth-child(1) {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding-left: 30px;
        }
        &:nth-child(2) {
          .activeTab {
            font-weight: bolder;
            @include fun-design(2);
          }
        }
        &:nth-child(3) {
          overflow: hidden;
          display: flex;
          align-items: center;
          background-color: #fff;
          > div {
            height: 50px;
            line-height: 20px;
          }
          .logoStr {
            @include fun-design(0);
            font-size: 16px;
            line-height: 50px;
            font-weight: bold;
            margin-left: 10px;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
    }
    &-popover {
      height: 254px;
      display: flex;
      flex-direction: column;
      > div {
        &:nth-child(1) {
          height: 53.85%;
          border-bottom: 1px solid #f2f2f2;
          display: flex;
          align-items: center;
          padding-left: 12px;
          > span {
            width: calc(100% - 50px);
            margin-right: 10px;
          }
        }
        &:nth-child(2) {
          flex: 1;
          display: flex;
          // padding:12px 20px 14px 20px;
          padding: 12px;
          flex-direction: column;
          > span {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
          }
        }
      }
    }
  }
  &-content {
    display: flex;
    margin: 0 auto;
    min-height: 100vh;
    flex:1;
    // position: absolute;
    // top: 72px;
    // bottom: 0px;
    // overflow: hidden;
     min-width:$xr-min-width;
    > section {
      width: 100%;
      min-height: 100%;
      display:flex;
      flex-direction: column;
      .routerBox{
        flex:1;
        display: flex;
        justify-content: center
      }
      .Layout-content-btns {
      @include fun-design(3);
      height: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      > div {
        flex: 1;
        font-size: 14px;
      }
    }
    }

  }
}
.popoverRoute {
  cursor: pointer;
  line-height: 35px;
  padding-left: 10px;
}
.popoverRoute /deep/ .el-badge__content.is-fixed {
  right: 2px;
  top: 5px;
}

/deep/ .el-menu-item{
  width: 120px;
}
.leftBox{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
}
    .phone{
      display: flex;
      align-items: center;
      margin-top: 2px;
      height: 20px;
      img{
        width:16px;
        height:16px;
        margin-top:4px;
      }
      span{
        line-height: 1;
      }
    }
</style>
